import {
  AlertTriangle,
  Building2,
  Bus,
  Car,
  ClipboardList,
  Download,
  FileText,
  IdCard,
  MapPin,
  Ruler,
  Route,
  Settings,
  Stethoscope,
  Truck,
  UserCheck,
  Users,
} from 'lucide-react';

export const MENU_LABELS_PT = {
  boletim: 'Boletim',
  'producao-bpa': 'Produção BPA',
  'gera-bpa': 'Gera BPA',
  'pacientes-incompletos': 'Pacientes Incompletos',
  usuarios: 'Usuários',
  bpa: 'BPA',
  'bpa-viagem': 'Viagem',
  'bpa-transporte': 'BPA Transporte',
  transport: 'Transporte',
  'transport-rides': 'Corridas',
  'transport-boardings': 'Embarques',
  'transport-reports': 'Relatórios',
  'transport-drivers': 'Motoristas',
  'transport-vehicles': 'Veículos',
  'transport-patients': 'Passageiros',
  'transport-cities': 'Cidades',
  'transport-facilities': 'Estabelecimentos',
  'transport-specialties': 'Especialidades',
  'transport-distances': 'Distâncias',
};

export const MENU_ICONS = {
  boletim: FileText,
  bpa: ClipboardList,
  usuarios: Users,
  transport: Truck,
  'producao-bpa': Settings,
  'gera-bpa': Download,
  'pacientes-incompletos': AlertTriangle,
  'bpa-viagem': Route,
  'bpa-transporte': Bus,
  'transport-rides': Route,
  'transport-boardings': UserCheck,
  'transport-reports': ClipboardList,
  'transport-drivers': IdCard,
  'transport-vehicles': Car,
  'transport-patients': Users,
  'transport-cities': MapPin,
  'transport-facilities': Building2,
  'transport-specialties': Stethoscope,
  'transport-distances': Ruler,
};

export function getMenuLabel(menu) {
  if (!menu) return '';
  return MENU_LABELS_PT[menu.name] || menu.label;
}

export function getMenuIcon(menuName) {
  return MENU_ICONS[menuName] || FileText;
}

export function getRoleLabel(role) {
  if (role === 'admin') return 'Administrador';
  if (role === 'user') return 'Usuário';
  return role || 'Usuário';
}
